import React, { useState, useEffect } from "react";
import "./index.css";
import $ from "jquery";

import Loading from "../Loading";

import BRUNCH_MENU from "../../Assets/menus/BBs_Brunch_Menu_Front.png";
import DINER_MENU from "../../Assets/menus/BBs_Dinner_Menu_Front.png";
import DRINKS_MENU from "../../Assets/menus/BBs_drinks_back.png";

const Navigation = () => {
  const [loading, setLoading] = useState(false);
  const [showReso, setShowReso] = useState(false);

  useEffect(() => {
    if (showReso) {
      $(".reservation-options").fadeIn(300);
    } else {
      $(".reservation-options").fadeOut(100);
    }
  }, [showReso]);

  return (
    <>
      <div className="home-page-copy-content">
        <nav className="navigation">
          <ul>
            <li className="nav-toggle">
              <h1>
                <a href={BRUNCH_MENU} target="_blank" rel="noopener noreferrer">
                  Brunch Menu
                </a>
              </h1>
            </li>
            <li className="nav-toggle">
              <h1>
                <a href={DINER_MENU} target="_blank" rel="noopener noreferrer">
                  Dinner Menu
                </a>
              </h1>
            </li>
            <li className="nav-toggle">
              <h1>
                <a href={DRINKS_MENU} target="_blank" rel="noopener noreferrer">
                  Drinks Menu
                </a>
              </h1>
            </li>
            <li>
              <h1>
                <a
                  href="https://www.opentable.ca/r/bbs-diner-toronto?page=2"
                  target="_blank"
                >
                  Reservations
                </a>
              </h1>
            </li>
          </ul>
        </nav>
        <article className="location-information">
          <ul>
            <li>
              <h2>Brunch: Monday - Sunday 10:00am to 3:00pm</h2>
            </li>
            <li>
              <h2>Dinner: Wednesday - Saturday 5:00pm to 10:00pm</h2>
            </li>
            <br />
            <li>
              <a href="https://www.google.com/maps/place/5+Brock+Ave,+Toronto,+ON+M6K+2K6/@43.6415977,-79.434818,17z/data=!3m1!4b1!4m6!3m5!1s0x882b35ac8aa3f51d:0x2543cf6c8eb6e232!8m2!3d43.6415938!4d-79.4322431!16s%2Fg%2F11csmpj__s">
                <h2> 5 Brock Avenue </h2>
                <h2> Toronto, ON M6K 2K6 </h2>
              </a>
            </li>
          </ul>
        </article>
        <article className="contact-information">
          <ul>
            <li>
              <a href="mailto:info@bbs.restaurant">
                <h3> info@bbs.restaurant </h3>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/bbs.bbs.bbs.bbs.bbs">
                <h3> @bbs.bbs.bbs.bbs.bbs </h3>
              </a>
            </li>
            <li>
              <a href="tel:416-668-2023">
                <h3> 416-668-2023 </h3>
              </a>
            </li>
          </ul>
        </article>
      </div>
      {loading === true ? <Loading /> : null}
    </>
  );
};

export default Navigation;
